<div class="modal fade document-rename-modal" [id]="modalId" msEscClose (escPressed)="cancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title text-break">{{ title() }}</h5>
            </div>
            <div class="modal-body px-4">
                <form [formGroup]="form" (ngSubmit)="submit()">
                    <label class="form-label small text-secondary-emphasis">{{ isFileMode() ? 'File name' : 'Folder name' }}</label>
                    <div class="input-group has-validation">
                        <input type="text" class="form-control" formControlName="name"
                            [placeholder]="placeholder()" autocomplete="off" [maxlength]="nameMaxLength()"
                            (focus)="isNameFocused.set(true)" (blur)="isNameFocused.set(false)"
                            [class.is-invalid]="errorMessage() !== '' || (!isNameFocused() && form.get('name')?.invalid && form.get('name')?.touched)" />
                        @if (isFileMode() && fileExtension()) {
                            <span class="input-group-text text-secondary">{{ fileExtension() }}</span>
                        }
                    </div>
                    @if (errorMessage()) {
                        <div class="text-danger small mt-2">{{ errorMessage() }}</div>
                    } @else if (!isNameFocused() && form.get('name')?.errors?.['required'] && form.get('name')?.touched) {
                        <div class="text-danger small mt-2">A name is required.</div>
                    }

                    @if (isCreateMode() && canChoosePermission()) {
                        <div class="mt-4">
                            <label class="form-label small text-secondary-emphasis">Permission</label>
                            <div class="d-flex flex-column gap-2">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="folderPermission" id="permAdminOnly"
                                        [checked]="selectedPermission() === DocumentPermission.AdminOnly"
                                        (change)="choosePermission(DocumentPermission.AdminOnly)" />
                                    <label class="form-check-label" for="permAdminOnly">
                                        <fa-duotone-icon icon="lock" secondaryOpacity="0.4" class="me-2" />
                                        <strong>Admin only</strong> — only org admins can see contents.
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="folderPermission" id="permMemberRead"
                                        [checked]="selectedPermission() === DocumentPermission.MemberRead"
                                        (change)="choosePermission(DocumentPermission.MemberRead)" />
                                    <label class="form-check-label" for="permMemberRead">
                                        <fa-duotone-icon icon="users" secondaryOpacity="0.4" class="me-2" />
                                        <strong>Member read</strong> — visible to all members.
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="folderPermission" id="permPublic"
                                        [checked]="selectedPermission() === DocumentPermission.Public"
                                        (change)="choosePermission(DocumentPermission.Public)" />
                                    <label class="form-check-label" for="permPublic">
                                        <fa-duotone-icon icon="globe" secondaryOpacity="0.4" class="me-2" />
                                        <strong>Public</strong> — anyone with the link can fetch contents.
                                    </label>
                                </div>
                            </div>
                        </div>
                    } @else if (isCreateMode()) {
                        <div class="mt-3 text-secondary small">
                            <fa-duotone-icon icon="lock" secondaryOpacity="0.4" class="me-1" />
                            Inherits the parent folder's permission@if (inheritedPermissionLabel()) { ({{ inheritedPermissionLabel() }})}. Only top-level folders set permission.
                        </div>
                    }
                </form>
            </div>
            <div class="modal-footer border-0 d-flex justify-content-center pb-4 gap-2">
                <button type="button" class="btn btn-ms-secondary px-4" (click)="cancel()" [disabled]="isSubmitting">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary px-4" (click)="submit()" [disabled]="isSubmitting">
                    @if (isSubmitting) {
                        <span class="spinner-border spinner-border-sm me-2"></span>
                    }
                    @if (isCreateMode()) { Create } @else { Save }
                </button>
            </div>
        </div>
    </div>
</div>
